import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Sad({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Sad</title>
      <g clipPath="url(#clip0_3458_6455)">
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="9.5" cy="9.5" r="1.5" fill={color ?? 'currentColor'} />
        <circle cx="14.5" cy="9.5" r="1.5" fill={color ?? 'currentColor'} />
        <path
          d="M7.53803 15.6064C8.79314 14.5681 10.3711 14 12 14C13.6289 14 15.2069 14.5681 16.462 15.6064"
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3458_6455">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
